<script lang="ts">
	//Helpers
	import { is_gen_2 } from '../../../helpers/interface_helpers';
	//Stores
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	//Components
	import NetworkConnectedStatus from './NetworkConnectedStatus.svelte';

	export let isOffline: boolean = false;
	export let id: string, ssid: string;
	const gen = is_gen_2($devices[id]);
	export let classes: string = '';

	$: statusStore = getDeviceStatus(id);
	$: wifi_status = !gen ? $statusStore?.wifi_sta : $statusStore?.wifi;
	$: connected =
		ssid === wifi_status?.ssid && (!gen ? wifi_status?.connected : wifi_status?.status === 'got ip');
	$: ip = !gen ? wifi_status?.ip : wifi_status?.sta_ip;
</script>

<NetworkConnectedStatus {isOffline} {connected} {ip} {ssid} {classes} />
